import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

const PATH_TEMPLATE = '/questionnaires/{questionnaireId}/section-template/{sectionTemplateId}/pdf-fill-json';
type ThisApi = ApiDefinition[typeof PATH_TEMPLATE]['PUT'];
type Input = ThisApi['params'] & ThisApi['query'] & ThisApi['body'];

const updatePdfFillJson = async ({
  questionnaireId,
  sectionTemplateId,
  jsonData,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>(PATH_TEMPLATE, {
    questionnaireId,
    sectionTemplateId,
  });
  const response = await formsBackendClient.put(path, {
    jsonData,
  });
  return response.data;
};

export default updatePdfFillJson;
